var English = "英語";
var French = "フランス語";
var German = "ドイツ語";
var Italian = "イタリア語";
var Japanese = "日本語";
var Korean = "韓国語";
var Portuguese = "ポルトガル語";
var Russian = "ロシア語";
var Spanish = "スペイン語";
var Bahasa = "インドネシア語";
var Thai = "タイ語";
var Vietnamese = "ベトナム語";
var Turkish = "トルコ語";
var Arabic = "アラビア語";
var languagePreference = {
	English: English,
	French: French,
	German: German,
	Italian: Italian,
	Japanese: Japanese,
	Korean: Korean,
	Portuguese: Portuguese,
	Russian: Russian,
	"Chinese-Simplified": "簡体字中国語",
	"Chinese-Traditional": "繁体字中国語",
	Spanish: Spanish,
	Bahasa: Bahasa,
	Thai: Thai,
	Vietnamese: Vietnamese,
	Turkish: Turkish,
	Arabic: Arabic
};

export { Arabic, Bahasa, English, French, German, Italian, Japanese, Korean, Portuguese, Russian, Spanish, Thai, Turkish, Vietnamese, languagePreference as default };
